export const ReadAloudContentModes = {
  ANSWER: "answer",
  ARTICLE: "article",
  QUIZ: "quiz",
};
